import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "ApiClient";
import { ApiURL } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { showErrorModal } from "utils/hooks/handleNotification";
import { StudentQualType } from "utils/Types";
import { common } from "utils/Wording";

type Year11QualSliceType = {
  data: StudentQualType;
  isLoading: boolean;
  isLoadingError: boolean;
};

const Year11QualInit: Year11QualSliceType = {
  data: {} as Year11QualSliceType["data"],
  isLoading: false,
  isLoadingError: false
};

export const fetchYear11Qual = createAsyncThunk("/year11Qual", async (refNum: number) => {
  if (!refNum) {
    throw new Error(common.loadingError);
  }

  try {
    const res = await api.get(`${ApiURL.year11Qual}/${String(refNum)}`);
    if (res?.data?.status === API_RESPONSE_STATUS.ERROR) {
      throw new Error(common.loadingError);
    }
    return res?.data?.data ? res.data.data : [];
  } catch (error: any) {
    showErrorModal({
      title: common.failAsync,
      errors: error.response?.data?.errors ? error.response.data.errors : [error.message]
    });
    return Year11QualInit.data;
  }
});

export const Year11QualSlice = createSlice({
  name: "year11-qual",
  initialState: Year11QualInit,
  reducers: {
    setYear11Qual: (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchYear11Qual.pending, state => {
      state.isLoading = true;
      state.isLoadingError = false;
    });
    builder.addCase(fetchYear11Qual.fulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }),
      builder.addCase(fetchYear11Qual.rejected, () => {
        return {
          data: Year11QualInit.data,
          isLoading: false,
          isLoadingError: true
        };
      });
  }
});

export const { setYear11Qual } = Year11QualSlice.actions;

export default Year11QualSlice.reducer;
